window.booleanFormatter = function(value, row) {
    if (value === 1 || value === "1" || value === "true" || value === true) {
        return '<i class="fa fa-check boolean-formatter"></i>';
    }
};
